import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { siteSpecificData } from '../../../environments/site-specific-data';
import { LeaseDetails } from '../models/lease-details';
import { LeaseType } from '../models/lease-type';

const API_URL = siteSpecificData.apiUrlBase;

@Injectable()
export class LeaseDetailsHttpService {
  constructor(private http: HttpClient) { }

  getLeaseDetailsByRef(leaseRef: number): Observable<LeaseDetails> {
    const leaseDetailByRefUrl = `${API_URL}lease/details/${leaseRef}`;
    return this.http.get<LeaseDetails>(leaseDetailByRefUrl);
  }

  getLeaseTypes(): Observable<LeaseType[]> {
    const leaseDetailByRefUrl = `${API_URL}lease/types`;
    return this.http.get<LeaseType[]>(leaseDetailByRefUrl);
  }

}
